import React, { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { ImageThumbnails } from '../image_thumbnails/ImageThumbnails';
import { ContactAvatar } from '../contact_avatar/ContactAvatar';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import {
	contactsRestCrudThunksForBuyer,
	contactsRestCrudThunksForSupplier,
} from '../../thunks/contacts_thunks';
import moment from 'moment';

const SimpleMessageBubble = ({ currentUser, n, idx, userType }) => {
	const getName = useCallback((userContact) => {
		return `-- ${nullSafeGet('noteAddedByContact.nameGiven', userContact)} ${nullSafeGet(
			'noteAddedByContact.nameFamily',
			userContact
		)}`;
	}, []);

	const isMe = useMemo(
		() => nullSafeGet('noteAddedBy', n) === nullSafeGet('email', currentUser),
		[n, currentUser]
	);

	return (
		<li className={`${isMe ? 'me mr-[120px]' : 'him ml-[120px]'}`} key={idx}>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
				}}
			>
				<div style={{ fontSize: 16, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
					{n.text}
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between',
						alignItems: 'flex-end',
					}}
				>
					<div className={`name mr-2`}>{getName(n)}</div>
					<div
						style={{
							display: 'flex',
							fontSize: '10px',
							color: isMe ? 'rgba(209,230,250,1)' : '#aaa',
						}}
					>
						{moment(n.noteAddedAt).format('MMM DD, h:mm a')}
					</div>
				</div>
			</div>
			{n.photo ? <ImageThumbnails photoStrings={[n.photo]} /> : null}
			<div className="time">
				{isMe
					? [
							<div key={1} style={{ marginRight: 8 }} className={'justify-center'}>
								<ContactAvatar contact={n.noteAddedByContact} userType={userType} />
							</div>,
					  ]
					: [
							<div key={1} style={{ marginLeft: 8 }}>
								<ContactAvatar contact={n.noteAddedByContact} userType={userType} />
							</div>,
					  ]}
			</div>
		</li>
	);
};

const mapStateToProps = (state) => ({
	all_contacts: state.all_contacts,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getContacts: (ids) => {
		if (ownProps.userType === 'supplier') {
			return dispatch(
				contactsRestCrudThunksForSupplier.readMultiple(ids, 'contactsIndex', null, null, null, true)
			);
		}
		return dispatch(
			contactsRestCrudThunksForBuyer.readMultiple(ids, 'contactsIndex', null, null, null, true)
		);
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(SimpleMessageBubble);
